export enum GeneralNotificationEnum {
  ACCOUNT_VERIFIED = "ACCOUNT_VERIFIED",
  PROFILE_VIEWED = "PROFILE_VIEWED",
  ENTITY_PROFILE_VIEWED = "ENTITY_PROFILE_VIEWED",
  MENTION_IN_POST = "MENTION_IN_POST",
  MENTION_IN_COMMENT = "MENTION_IN_COMMENT",
  MENTION_IN_REPLY = "MENTION_IN_REPLY",
  LIKED_POST = "LIKED_POST",
  LIKED_COMMENT = "LIKED_COMMENT",
  ADD_COMMENT = "ADD_COMMENT",
  REPLY = "REPLY",
  REPOST = "REPOST",
  SHARE = "SHARE",
  FOLLOW = "FOLLOW",
  PROFESSIONAL_REQUEST = "PROFESSIONAL_REQUEST",
  FRIEND_REQUEST = "FRIEND_REQUEST",
  REQUEST_ACCEPTED = "REQUEST_ACCEPTED",
  MINOR_RECEIVES_PROFESSIONAL_REQUEST = "MINOR_RECEIVES_PROFESSIONAL_REQUEST",
  MINOR_SENDS_PROFESSIONAL_REQUEST = "MINOR_SENDS_PROFESSIONAL_REQUEST",
  MINOR_DELETE_REQUEST_ACCEPTED = "MINOR_DELETE_REQUEST_ACCEPTED",
  MINOR_ADD_REQUEST_ACCEPTED = "MINOR_ADD_REQUEST_ACCEPTED",
  MINOR_ADD_REQUEST_APPROVED = "MINOR_ADD_REQUEST_APPROVED",
  MINOR_DECLINE_REQUEST = "MINOR_DECLINE_REQUEST",
  MINOR_DELETE_REQUEST = "MINOR_DELETE_REQUEST",
  GUARDIAN_FORM_ACCEPT = "GUARDIAN_FORM_ACCEPT",
  GUARDIAN_FORM_REJECT = "GUARDIAN_FORM_REJECT",
  REVIEW_RECEIVED = "REVIEW_RECEIVED",
  REVIEW_ACCEPTED = "REVIEW_ACCEPTED",
  REVIEW_UPDATED = "REVIEW_UPDATED",
  REVIEW_REQUEST_REVISION = "REVIEW_REQUEST_REVISION",
  CHALLENGE_INVITATION = "CHALLENGE_INVITATION",
  CHALLENGE_JOINED = "CHALLENGE_JOINED",
}

export enum GoServiceNotificationEnum {
  GOSERVICE_PROFILE_VIEWED = "GOSERVICE_PROFILE_VIEWED",
  GOSERVICE_CANCEL_REQUEST = "GOSERVICE_CANCEL_REQUEST",
  GOSERVICE_APPROVED = "GOSERVICE_APPROVED",
  GOSERVICE_REJECTED = "GOSERVICE_REJECTED",
  GOSERVICE_REQUESTED = "GOSERVICE_REQUESTED",
  GOSERVICE_REQUEST_DECLINED = "GOSERVICE_REQUEST_DECLINED",
  GOSERVICE_REQUEST_CANCELLED = "GOSERVICE_REQUEST_CANCELLED",
  GOSERVICE_SERVICE_CREATED = "GOSERVICE_SERVICE_CREATED",
  GOSERVICE_CHAT_MESSAGE_SENT = "GOSERVICE_CHAT_MESSAGE_SENT",
  GOSERVICE_WITHDRAWAL_CONTRACT_REQUESTED = "GOSERVICE_WITHDRAWAL_CONTRACT_REQUESTED",
  GOSERVICE_CONTRACT_APPROVED = "GOSERVICE_CONTRACT_APPROVED",
  GOSERVICE_CONTRACT_DECLINED = "GOSERVICE_CONTRACT_DECLINED",
  GOSERVICE_CONTRACTED = "GOSERVICE_CONTRACTED",
  GOSERVICE_CONTRACT_MILESTONE_ACHIEVED = "GOSERVICE_CONTRACT_MILESTONE_ACHIEVED",
  GOSERVICE_CONTRACT_MILESTONE_COMPLETED_REMINDER = "GOSERVICE_CONTRACT_MILESTONE_COMPLETED_REMINDER",
  GOSERVICE_CONTRACT_MILESTONE_RELEASED = "GOSERVICE_CONTRACT_MILESTONE_RELEASED",
  GOSERVICE_CONTRACT_PAID = "GOSERVICE_CONTRACT_PAID",
  GOSERVICE_REQUEST_FEEDBACK = "GOSERVICE_REQUEST_FEEDBACK",
  GOSERVICE_FEEDBACK_ADDED_BY_PROVIDER = "GOSERVICE_FEEDBACK_ADDED_BY_PROVIDER",
  GOSERVICE_FEEDBACK_ADDED_BY_REQUESTER = "GOSERVICE_FEEDBACK_ADDED_BY_REQUESTER",
  GOSERVICE_PROGRAM_PAID = "GOSERVICE_PROGRAM_PAID",
  GOSERVICE_CONTRACT_CANCELLED_AFTER_PAID = "GOSERVICE_CONTRACT_CANCELLED_AFTER_PAID",
}
export const GoServiceNotificationTypes: NotificationType[] = Object.values(GoServiceNotificationEnum);
export const isGoServiceNotification = (type: NotificationType): boolean => GoServiceNotificationTypes.includes(type);

export enum EventNotificationEnum {
  MATCH_JOIN_REQUEST = "GAME_JOIN_REQUEST",
  TRAINING_JOIN_REQUEST = "TRAINING_JOIN_REQUEST",
  MATCH_INVITATION = "MATCH_INVITATION",
  EVENT_INVITATION = "EVENT_INVITATION",
  TRAINING_INVITATION = "TRAINING_INVITATION",

  EVENT_JOIN_REQUEST = "EVENT_JOIN_REQUEST",
  EVENT_JOIN_REQUEST_ACCEPTED = "EVENT_JOIN_REQUEST_ACCEPTED",
  EVENT_JOIN_REQUEST_DECLINED = "EVENT_JOIN_REQUEST_DECLINED",
  ACCEPT_EVENT_INVITATION = "ACCEPT_EVENT_INVITATION",
  REJECT_EVENT_INVITATION = "REJECT_EVENT_INVITATION",
  EVENT_PLAYER_REMOVED = "EVENT_PLAYER_REMOVED",

  PLAYER_LEFT_MATCH = "PLAYER_LEFT_MATCH",
  PLAYER_LEFT_TRAINING = "PLAYER_LEFT_TRAINING",

  MATCH_CANCELLED = "MATCH_CANCELLED",
  TRAINING_CANCELLED = "TRAINING_CANCELLED",
}

export enum MassOfferNotificationEnum {
  PROFILE_OFFER = "PROFILE_OFFER",
  PROFILE_OFFER_RESPONSE = "PROFILE_OFFER_RESPONSE",
  OFFER_EXPIRED = "OFFER_EXPIRED",
  OFFER_NEAR_EXPIRY = "OFFER_NEAR_EXPIRY",
}

export enum GoHireNotificationEnum {
  JOB_APPLICATION_RECEIVED = "JOB_APPLICATION_RECEIVED",
  JOB_APPROVED = "JOB_APPROVED",
}
export const NotificationEnum = {
  ...GeneralNotificationEnum,
  ...GoServiceNotificationEnum,
  ...EventNotificationEnum,
  ...MassOfferNotificationEnum,
  ...GoHireNotificationEnum,
} as const;

export type NotificationType = (typeof NotificationEnum)[keyof typeof NotificationEnum];

export enum NotificationCategoryEnum {
  GENERAL = "general",
  GO_ALERT = "goAlert",
}
export const notificationCategoriesList: NotificationCategoryEnum[] = Object.values(NotificationCategoryEnum);
